import i18n from '../../../../../../../i18n'

export const TRIVIA_TABS = {
    startView: 1,
    questionList: 2,
    resultList: 3,
}

export const TRIVIA_TABS_ARRAY = [
    {
        id: TRIVIA_TABS.startView,
        label: i18n.t('Start screen'),
    },
    {
        id: TRIVIA_TABS.questionList,
        label: i18n.t('Questions'),
    },
    {
        id: TRIVIA_TABS.resultList,
        label: i18n.t('Results'),
    },
]
